import { useLocation, useNavigate, useParams } from "react-router-dom";
import { blogPosts } from "./blogData";
import ReactMarkdown from "react-markdown";
import { Helmet } from "react-helmet-async";
import TopbarInner from "../components/topbar/TopbarInner";

export default function BlogArticle({ showThemeDropdown = true }) {
  const navigate = useNavigate();
  const location = useLocation();
const handleArticleBack = () => {
  if (location.state?.from === "/blog") {
    navigate(-1);
    return;
  }

  navigate("/blog", { replace: true });
};
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div className="blog-article-page">
        <p>Article introuvable.</p>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{`${post.title} | Harmonauria`}</title>
        <meta name="description" content={post.excerpt} />
        <link rel="canonical" href={`https://harmonauria.fr/blog/${post.slug}`} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={post.title} />
        <meta property="og:description" content={post.excerpt} />
        <meta property="og:url" content={`https://harmonauria.fr/blog/${post.slug}`} />
        <meta property="og:image" content={`https://harmonauria.fr${post.image}`} />
      </Helmet>

<TopbarInner
  title="Blog"
  onBack={handleArticleBack}
  onLogoClick={() => navigate("/")}
  titleColor="#36495B"
  showThemeDropdown={showThemeDropdown}
/>

<div className="blog-article-page" role="main">
      {/* === Haut de page === */}
      <div className="page-top">
        <div className="article-hero-image">
          <img
            src={post.image}
            alt={`Illustration : ${post.title}`}
            className="hero-image"
          />
        </div>

        <header className="header" aria-labelledby="article-title">
          <h1 id="article-title" className="h1-brand">
            {post.title}
          </h1>
        </header>
      </div>

      <div className="article-meta">
        <span className="article-chip">{post.readingTime} de lecture</span>
      </div>

      {/* Intro */}
      <div className="article-intro">
        <ReactMarkdown>{post.intro}</ReactMarkdown>
      </div>

      {/* Contenu */}
<div className="article-body">
  {post.sections.map((section) => (
    <section key={section.heading} className="article-section">
      <h2 className="article-subtitle">{section.heading}</h2>

      {section.paragraphs?.map((p, idx) => (
        <div key={idx} className="article-text">
          <ReactMarkdown>{p}</ReactMarkdown>
        </div>
      ))}

{section.table && (
  <div className="article-table-wrap">
    <div className="article-table-scroll">
      <table className="article-table">
        <thead>
          <tr>
            {section.table.headers.map((header, index) => (
              <th key={index}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {section.table.rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <td key={cellIndex}>
                  {cellIndex === 0 ? <strong>{cell}</strong> : cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}
</section>
))}

  {post.outro && (
    <div className="article-outro">
      <ReactMarkdown>{post.outro}</ReactMarkdown>
    </div>
  )}

<div className="article-site-cta">
  <p className="article-site-cta__eyebrow">Envie de souffler quelques minutes ?</p>
  <h2 className="article-site-cta__title">Découvrez Harmonauria</h2>
  <p className="article-site-cta__text">Respirations guidées, musiques et paysages sonores pour retrouver un peu de calme.</p>

  <button
    type="button"
    className="article-site-cta__button"
    onClick={() => navigate("/")}
  >
    Commencer gratuitement
  </button>
</div>

<div className="article-bottom-nav">
<button
  className="article-back-btn"
  onClick={handleArticleBack}
>
  ← Voir tous les articles
</button>
        </div>
      </div>

      <style>{`
        :root{
          --brand1:#61837A; --brand2:#36495B;
          --ink-1:#0f172a;
          --s1:8px; --s2:12px; --s3:16px; --s4:24px;
          --s5:32px; --s6:40px; --s7:56px; --s8:72px;
        }

.blog-article-page{
  margin-top: var(--topbar-height, 56px);
  padding: 32px var(--s3) var(--s8);
  display:flex;
  flex-direction:column;
  align-items:center;
  gap: var(--s5);
  font-family:system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;
  width:100%;
  max-width:100vw;
  overflow-x:hidden;
  background:#fff;
  min-height:calc(100vh - var(--topbar-height, 56px));
}

        .page-top{
          position: relative;
          width: 100%;
          max-width: 840px;
          margin: 0 auto var(--s3);
          padding-top: var(--s3);
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: var(--s2);
        }

        .article-hero-image {
          width: 100%;
          max-width: 840px;
          margin: 0 auto var(--s4);
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
        }

        .hero-image {
          width: 100%;
          height: auto;
          max-height: 420px;
          object-fit: cover;
          display: block;
        }

        @media (max-width: 767px) {
          .article-hero-image {
            border-radius: 12px;
            margin-bottom: var(--s3);
          }
          
          .hero-image {
            max-height: 280px;
          }
        }

        .header{
          display:flex;
          align-items:center;
          justify-content:center;
          width:100%;
        }

        /* Titre simple */
        .h1-brand,
        .h1-brand:hover,
        .h1-brand:focus-visible{
          font-family:"Sora",system-ui,sans-serif;
          font-weight:800;
          font-size:clamp(28px,5.6vw,42px);
          color:var(--brand1);
          text-align:center;
          margin:0;
          line-height:1.1;
          background: transparent !important;
          box-shadow: none !important;
          text-shadow: none !important;
          filter: none !important;
          transform: none !important;
          transition: none !important;
          cursor: default;
        }

        .article-meta{
          display:flex;
          flex-wrap:wrap;
          gap: 8px;
          align-items:center;
          justify-content:center;
          max-width:840px;
          width:100%;
        }

        .article-chip{
          padding:5px 12px;
          border-radius:999px;
          font-size:0.8rem;
          font-weight:600;
          color:#56766e;
          background:#edf5f2;
          border:1px solid #dcebe6;
        }

        .article-intro{
          max-width:820px;
          margin:0 auto var(--s3);
          font-size:1.02rem;
          color:#475569;
          line-height:1.7;
          text-align:left;
        }

        .article-body{
          max-width:820px;
          width:100%;
          margin:0 auto;
        }

        .article-section{
          margin-bottom: var(--s5);
        }

        .article-subtitle{
          font-size:1.25rem;
          font-weight:700;
          color:var(--brand2);
          margin:0 0 var(--s2);
        }

        .article-text{
          font-size:1.02rem;
          color:#1f2937;
          line-height:1.8;
          margin:0 0 var(--s2);
        }

        .article-outro{
          font-size:1.02rem;
          color:#111827;
          line-height:1.8;
          font-weight:500;
          margin-top:var(--s4);
        }

        .article-intro p,
        .article-text p,
        .article-outro p {
          margin: 0 0 var(--s2);
        }

        .article-intro strong,
        .article-text strong,
        .article-outro strong {
          font-weight: 700;
          color: var(--brand1);
        }

        .article-intro p:last-child,
        .article-text p:last-child,
        .article-outro p:last-child {
          margin-bottom: 0;
        }

        .article-subtitle{
          font-size:1.15rem;
        }

        .article-site-cta {
  width: 100%;
  margin-top: var(--s6);
  padding: 32px 26px;
  border: 1px solid rgba(97, 131, 122, 0.16);
  border-radius: 22px;
  background: rgba(203, 226, 219, 0.2);
  text-align: center;
}

.article-site-cta__eyebrow {
  margin: 0 0 8px;
  color: #61837a;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.article-site-cta__title {
  margin: 0;
  color: #203e3e;
  font-family: "Nunito", sans-serif;
  font-size: 1.55rem;
  font-weight: 800;
}

.article-site-cta__text {
  max-width: 540px;
  margin: 10px auto 22px;
  color: #506866;
  font-size: 0.95rem;
  line-height: 1.65;
}

.article-site-cta__button {
  min-height: 48px;
  padding: 0 22px;
  border: 0;
  border-radius: 999px;
  background: #61837a;
  color: #ffffff;
  font-size: 0.92rem;
  font-weight: 800;
  cursor: pointer;
}
  
        .article-bottom-nav {
          margin-top: var(--s6);
          padding-top: var(--s3);
          border-top: 1px solid #e5e7eb;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
        }

        /* Bouton principal : retour au blog */
        .article-back-btn {
          padding: 12px 22px;
          border-radius: 999px;
          font-size: 0.95rem;
          font-weight: 700;
          border: none;
          background: var(--brand1);
          color: #ffffff;
          cursor: pointer;
          box-shadow: 0 6px 16px rgba(15,23,42,0.12);
          transition: background 0.2s ease, transform 0.1s ease, box-shadow 0.2s ease;
        }

        .article-back-btn:hover {
          background: #4e6f66;
          box-shadow: 0 10px 24px rgba(15,23,42,0.18);
        }

        .article-back-btn:active {
          transform: scale(0.97);
        }

@media (max-width: 767px){
  .blog-article-page{
    margin-top:var(--topbar-height, 56px);
    padding:24px var(--s2) var(--s7);
  }
}

.article-table-wrap{
  width: 100%;
  margin: 18px 0 22px;
}

.article-table-scroll{
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x;
  overscroll-behavior-x: contain;
  border-radius: 14px;
}

.article-table{
  width: 100%;
  min-width: 560px;
  border-collapse: collapse;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 6px 18px rgba(15,23,42,0.05);
}

.article-table th,
.article-table td{
  border: 1px solid #e5e7eb;
  padding: 12px 14px;
  text-align: left;
  vertical-align: top;
  font-size: 0.96rem;
  line-height: 1.5;
  color: #1f2937;
  white-space: normal;
}

.article-table th{
  background: #f8fafc;
  color: var(--brand2);
  font-weight: 700;
}

.article-table td strong{
  color: var(--brand1);
  font-weight: 700;
}

@media (max-width: 767px){
  .article-table-wrap{
    margin: 16px 0 20px;
  }

  .article-table-scroll{
    padding-bottom: 4px;
  }

  .article-table{
    min-width: 520px;
  }

  .article-table th,
  .article-table td{
    font-size: 0.92rem;
    padding: 10px 12px;
  }
}
      `}</style>
    </div>
    </>
  );
}